import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';
import { TeamSchemeDetailsSearchHandler } from './team-scheme-details-search.handler';

@Component({
  selector: 'sym-team-scheme-details-search',
  templateUrl: './team-scheme-details-search.component.html',
  styleUrls: ['./team-scheme-details-search.component.scss'],
})
export class TeamSchemeDetailsSearchComponent extends TeamSchemeDetailsSearchHandler implements OnInit {
  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
